module.exports = __webpack_public_path__ + "img/userIcon.a56eca51.png";